import React from 'react'

import { AcornsIcon, Icon } from '@acorns/icons'

import {
  Container,
  StyledButton,
  SubTitleMobile,
  TitleContainer,
  TitleMobile,
} from './styled-components'

type Props = {
  backgroundColor?: string
  handleBackPress: () => void
  handleClosePress?: () => void
  closeButton?: Icon
  subTitle?: string
  showCloseIcon?: boolean
  title?: string
}

const ActionStripMobile: React.FC<Props> = props => (
  <Container backgroundColor={props.backgroundColor}>
    <StyledButton aria-label="Back Button" onClick={props.handleBackPress}>
      {props.showCloseIcon ? (
        <AcornsIcon
          data-testid={'action_strip_mobile_x'}
          icon={props.closeButton ? props.closeButton : AcornsIcon.Icon.CloseXIcon}
          height={props.closeButton ? '16px' : '12px'}
          width="16px"
        />
      ) : (
        <AcornsIcon
          data-testid={'action_strip_mobile_back'}
          icon={AcornsIcon.Icon.ArrowLeft}
          height="12px"
          width="16px"
        />
      )}
    </StyledButton>
    <TitleContainer>
      <TitleMobile data-testid={'action_strip_mobile_title'}>{props.title}</TitleMobile>
      <SubTitleMobile>{props.subTitle}</SubTitleMobile>
    </TitleContainer>
  </Container>
)

export default ActionStripMobile
